import React, { Component } from 'react';
import ConfirmPopup from '../../../common/confirm-popup';

class ReverseScanDialog extends Component {
  render() {
    const { handleConfirmDialog } = this.props;

    return (
      <ConfirmPopup
        confirmLabel="Confirm"
        header="REVERSE SCAN"
        onClose={result => handleConfirmDialog(result)}
      >
        <div className="ta-left">
          <p>
            Are you sure you would like to reverse this scan?
            If points have been awarded for this scan, they will be removed from the incentive, outlet and user they were awarded to.
          </p>
        </div>
      </ConfirmPopup>
    );
  }
}

export default ReverseScanDialog;



// WEBPACK FOOTER //
// ./src/components/admin/scans/scans/reverse-scan-dialog.jsx